import { Link } from "react-router-dom";
import { ARTICLES } from "@/src/constants/articles";

export function ArticleGrid() {
    return (
        <section className="max-w-7xl mx-auto px-6 py-24">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16">
                {ARTICLES.map((article) => (
                    <Link key={article.id} to={`/journal/${article.id}`} className="group">
                        <div className="aspect-[16/9] overflow-hidden rounded-sm mb-6">
                            <img
                                src={article.image}
                                alt={article.title}
                                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                referrerPolicy="no-referrer"
                            />
                        </div>
                        <p className="text-xs uppercase tracking-widest text-stone-400 mb-3">
                            {article.category} — {article.date}
                        </p>
                        <h2 className="font-serif text-2xl mb-3 group-hover:italic transition-all">
                            {article.title}
                        </h2>
                        <p className="text-stone-500 font-light leading-relaxed">
                            {article.excerpt}
                        </p>
                    </Link>
                ))}
            </div>
        </section>
    );
}
